import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: string;
  title: string;
  description?: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toasts = signal<Toast[]>([]);
  readonly toasts = this._toasts.asReadonly();

  show(title: string, description?: string): void {
    const id = Math.random().toString(36).slice(2);
    this._toasts.update(list => [...list, { id, title, description }]);
    setTimeout(() => this.dismiss(id), 4000);
  }

  dismiss(id: string): void {
    this._toasts.update(list => list.filter(t => t.id !== id));
  }
}
